import $ from "jquery";

export default function () {
	// Initialize search when document is ready
	$(document).ready(function () {
		initBlogFilter();
	});

	/**
	 * Initialize blog filtering functionality.
	 */
	function initBlogFilter() {
		const $filtersContainer = $(".js-filter-holder"); // Keep this for toggleFeaturedPostsVisibility if needed
		const $resultsContainer = $(".js-load-more-target");
		// const $loadMoreButton = $(".js-load-more"); // No longer directly used here
		const $featuredPostsContainer = $(".dr-blog-posts-featured"); // Selector for the featured posts block
		// let isLoading = false; // State is likely managed within loadmore.js now

		// Check if results container exists (essential for toggleFeaturedPostsVisibility)
		if (!$resultsContainer.length) {
			return;
		}

		// --- Helper function to toggle Featured Posts visibility --- Remains for initial load
		function toggleFeaturedPostsVisibility() {
			if (!$featuredPostsContainer.length) {
				return;
			}

			const urlParams = new URLSearchParams(window.location.search);
			const industrySelected = urlParams.has("industry") && urlParams.get("industry") !== "";
			const onCategoryPage = window.location.pathname.includes("/blog/category/");

			const currentPage = parseInt($resultsContainer.data("paged") || 1);
			const slideCount = $featuredPostsContainer.find(".swiper-slide").length;

			const shouldShow = !industrySelected && !onCategoryPage && currentPage === 1;

			if (shouldShow) {
				// Check if it has actual slides before showing
				if (slideCount > 0) {
					$featuredPostsContainer.removeClass("uk-hidden");
					$(window).trigger("resize");
				} else {
					$featuredPostsContainer.addClass("uk-hidden");
				}
			} else {
				$featuredPostsContainer.addClass("uk-hidden");
			}
		}

		// Initial visibility check on page load
		toggleFeaturedPostsVisibility();

		// Re-check visibility after posts are updated via AJAX
		// $(document).on("dr_posts_updated", toggleFeaturedPostsVisibility);
	}
}
